import { render, staticRenderFns } from "./trading.vue?vue&type=template&id=28eb5053&"
import script from "./trading.vue?vue&type=script&lang=js&"
export * from "./trading.vue?vue&type=script&lang=js&"
import style0 from "./trading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports